import { ReactNode, useRef } from "react"
import classNames from "classnames"
import { useIsOnScreen } from "@/hooks/useIsOnScreen"
import "./index.scss"

interface LazyMountProps {
   children: ReactNode
   className?: string
}

const LazyMount = ({ children, className }: LazyMountProps) => {
   const ref = useRef<HTMLDivElement>(null)
   const isOnScreen = useIsOnScreen(ref)

   return (
      <div
         ref={ref}
         className={classNames("lazy-mount", className)}
      >
         {isOnScreen ? children : null}
      </div>
   )
}

export default LazyMount
